<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
  <rect x="0.5" y="0.5" width="17.5312" height="17.5312" rx="3.5" fill="#A0A3BD" fill-opacity="0.15" stroke="#A0A3BD" />
  <path
    d="M6.25 6.25L12.7812 12.7812"
    stroke="#A0A3BD"
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    d="M12.7812 6.25L6.25 12.7812"
    stroke="#A0A3BD"
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round" />
</svg>

